import React from 'react';

import type { ContactActivity } from '../../typescript-types/contact/contact-activity';

import { CONTACT_ACTIVITY_ITEM_CONFIGURATION } from '../../contact-activity/components/contact-activity-item-configuration';

import * as Status from '../../config/application-status-config';
import { MaterialDesignIcon } from '../../util/material-design-icons';

type Props = {
  contactActivity: ContactActivity;
};

export const CommentContactActivityDetails = ({ contactActivity }: Props) => {
  const { type, status: applicationStatusHistory } = contactActivity;

  if (type !== 'status' || !applicationStatusHistory) {
    return null;
  }
  const extraText = `Application status changed to ${Status.statusDisplay(
    applicationStatusHistory.status,
  )}`;

  const configurationForContactActivity = CONTACT_ACTIVITY_ITEM_CONFIGURATION[type];
  if (!configurationForContactActivity) {
    return <div className="typo-subtitle">{extraText}</div>;
  }

  const iconName = configurationForContactActivity.getIconComponentName(contactActivity);

  return (
    <div className="typo-subtitle u-flex-center">
      <MaterialDesignIcon iconName={iconName} className="typo-label" /> {extraText}
    </div>
  );
};
